import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1bc5c4ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chat-sidebar-search-bar" }
const _hoisted_2 = ["value", "placeholder"]

import Icon from "@/components/icons/Icon/Icon.vue";
import { MutationTypes, store, GetterTypes } from "@/store";
import { IconType } from "@/types/icons";
import { useComputedValue } from "@/composables";
import { useI18n } from "vue-i18n";
import { onMounted } from "vue";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatSidebarSearchBar',
  setup(__props) {

const { t } = useI18n();
const filter = useComputedValue<string>(GetterTypes.GET_CHATS_FILTER);
const { commit } = useStore();

onMounted(() => {
  commit(MutationTypes.CLEAR_CHATS_FILTER);
});

const updateFilter = (e: Event) => {
  const target = e.target as HTMLInputElement;
  store.commit(MutationTypes.SET_CHATS_FILTER, { filter: target.value });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      value: _unref(filter),
      placeholder: _unref(t)('chat.chatSidebar.SearchBar.placeholder'),
      onInput: updateFilter
    }, null, 40, _hoisted_2),
    _createVNode(Icon, {
      icon: _unref(IconType).MAGNIFY,
      class: "icon"
    }, null, 8, ["icon"])
  ]))
}
}

})